import React from "react";

const NotRequiredIcon = ({ className, fill, circleFill, circleStroke }) => (
  <svg
    className={className}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    {/* Circle */}
    <circle
      cx="210"
      cy="256"
      r="198"
      fill={circleFill} // Circle's fill color
      stroke={circleStroke} // Circle's stroke color
      strokeWidth="20"
    />
    {/* Icon Content */}
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path d="M1950 4339 c-116 -23 -227 -116 -272 -227 l-23 -57 0 -770 0 -770 23 -57 c64 -159 243 -260 404 -228 79 15 129 40 188 96 58 54 95 121 110 199 8 43 10 273 8 795 l-3 735 -24 60 c-33 81 -125 174 -201 202 -68 26 -151 35 -210 22z m184 -179 c20 -14 49 -43 64 -64 l27 -39 3 -762 2 -761 -23 -45 c-13 -24 -43 -57 -66 -74 -39 -27 -50 -30 -121 -30 -71 0 -82 3 -121 30 -23 17 -53 50 -66 74 l-23 45 2 761 3 761 25 38 c14 21 48 51 75 67 44 27 58 30 116 27 50 -3 75 -9 103 -28z" />
      <path d="M1930 2094 c-113 -30 -211 -117 -251 -222 -26 -68 -37 -264 -21 -353 23 -124 101 -226 210 -277 49 -23 70 -27 152 -27 81 0 103 4 150 26 107 50 176 134 206 249 24 94 16 303 -15 382 -42 108 -146 198 -260 224 -70 17 -102 17 -171 -2z m211 -179 c23 -17 53 -50 66 -74 21 -40 23 -57 23 -183 0 -117 -3 -145 -19 -176 -71 -139 -248 -163 -348 -49 -47 54 -55 93 -51 249 3 133 4 137 33 179 45 64 104 91 187 87 55 -3 75 -9 109 -33z" />
    </g>
  </svg>
);

export default NotRequiredIcon;
